<template>
  <div class="panzoom" :style="panZoomStyle">
    <div class="slot" :style="slotStyle">
      <slot />
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const appState = computed(() => store.state.app);
const panZoomStyle = computed(() => {
  const {
    canvasScale,
    editorSize: { wrapHeight },
  } = appState.value;
  const height = canvasScale * store.getters['app/croppedCanvasHeight'];
  return {
    width: canvasScale * store.getters['app/croppedCanvasWidth'] + 'px',
    height: height + 'px',
    // marginTop: height <= wrapHeight ? (wrapHeight - height) / 2 + 'px' : 0,
  };
});
const slotStyle = computed(() => {
  const { canvasScale, cropInfo, editorSize } = appState.value;
  const { left = 0, top = 0 } = cropInfo;
  const result = {
    width: canvasScale * editorSize.canvasWidth + 'px',
    height: canvasScale * editorSize.canvasHeight + 'px',
    left: -left * canvasScale + 'px',
    top: -top * canvasScale + 'px',
    // transform: `scale(${canvasScale})`,
  };
  console.log({ result, left, top, canvasScale });
  return result;
});
</script>
<style lang="less" scoped>
.panzoom {
  margin: 0 auto;
  position: relative;
  z-index: 9;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    left: 100%;
    top: 0;
    width: 10px;
    height: 1px;
  }
}

.slot {
  position: absolute;
  transform-origin: left top;
}
</style>
